import { inject } from '@angular/core';
import { catchError, map, of, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';

export function authCheckInitializer() {
  const authService = inject(AuthService);

  return authService.getUserInfo().pipe(
    tap(() => console.log('User authenticated')),
    map(() => true),
    catchError((error) => {
      authService.login(true);
      return of(false);
    })
  );
}
